import React, { useRef, useEffect } from "react";
import Select, { components } from "react-select";
import empty from "is-empty";
import DownArrowBlack from "src/asset/ic-dropdown-arr-black.svg";
import DownArrowWhite from "src/asset/ic-dropdown-arr-white.svg";
import CheckMarkWhite from "src/asset/dropdown-check.svg";

import styles from "./styles.module.scss";

const STYLE_DICT = {
    "thin-mint": {
        control: (state) => ({
            height: "36px",
            minHeight: "36px",
            borderRadius: "4px",
            border: "2px solid #3bd4ae",
            backgroundColor: "black",
            color: "white",
            padding: "0 12px",
            fontWeight: "bold",
            "&:hover": {
                borderColor: "#3bd4ae",
            },
        }),
        indicatorsContainer: {
            minHeight: "36px",
            height: "36px",
        },
        indicator: {
            src: DownArrowWhite,
            width: "24px",
        },
        dropdownIndicator: (state) => ({
            paddingTop: "4px",
            paddingRight: "0",
            img: {
                transform: state.selectProps.menuIsOpen ? "scaleY(-1)" : null,
            },
        }),
        valueContainer: {
            minHeight: "36px",
            height: "36px",
            padding: "0",
            fontSize: "13px",
        },
        singleValue: {
            minHeight: "32px",
            height: "32px",
            lineHeight: "32px",
        },
        placeholder: {
            color: "#777",
            minHeight: "32px",
            height: "32px",
            lineHeight: "28px",
        },
        option: (state) => ({
            display: "flex",
            padding: "0 12px",
            minHeight: "32px",
            lineHeight: "32px",
            color: state.isSelected ? "white" : "#aaa",
            backgroundColor: state.isFocused ? "#1c1c1c" : "black",
        }),
        menu: {
            marginTop: "0",
            backgroundColor: "black",
        },
    },

    "thick-black": {
        control: (state) => ({
            borderRadius: "0",
            backgroundColor: "black",
            opacity: state.isDisabled ? "0.4" : "1",
            height: "52px",
            minHeight: "52px",
            color: "white",
            padding: "0 24px",
        }),
        indicatorsContainer: {
            minHeight: "52px",
            height: "52px",
        },
        dropdownIndicator: (state) => ({
            paddingTop: "14px",
            paddingRight: "0",
            img: {
                transform: state.selectProps.menuIsOpen ? "scaleY(-1)" : null,
            },
        }),
        valueContainer: {
            minHeight: "52px",
            height: "52px",
            padding: "0",
            fontSize: "13px",
        },
        singleValue: {
            minHeight: "52px",
            height: "52px",
            lineHeight: "52px",
        },
        placeholder: {
            color: "white",
        },
        menu: {
            marginTop: "0",
            backgroundColor: "black",
        },
        menuList: {
            borderRadius: "0",
        },
        option: (state) => ({
            display: "flex",
            padding: "0 24px",
            minHeight: "48px",
            color: state.isSelected ? "white" : "#eeeeee",
            fontWeight: state.isSelected ? "bold" : "normal",
            backgroundColor: state.isFocused ? "#1c1c1c" : "black",
        }),
        indicator: {
            src: DownArrowWhite,
            width: "24px",
        },
    },

    "thick-black-2": {
        control: (state) => ({
            borderRadius: "0",
            backgroundColor: "black",
            opacity: state.isDisabled ? "0.4" : "1",
            height: "64px",
            minHeight: "64px",
            color: "white",
            padding: "0 13px",
        }),
        indicatorsContainer: {
            minHeight: "64px",
            height: "64px",
        },
        dropdownIndicator: (state) => ({
            paddingTop: "20px",
            paddingRight: "0",
            img: {
                transform: state.selectProps.menuIsOpen ? "scaleY(-1)" : null,
            },
        }),
        valueContainer: {
            minHeight: "64px",
            height: "64px",
            padding: "0",
            fontSize: "13px",
        },
        singleValue: {
            minHeight: "64px",
            height: "64px",
            lineHeight: "64px",
        },
        placeholder: {
            color: "white",
        },
        menu: {
            width: "100%",
            marginTop: "0",
            backgroundColor: "black",
            borderTop: "1px solid #262a29",
        },
        menuList: {
            borderRadius: "0",
            overflow: "visible",
        },
        option: (state) => ({
            display: "flex",
            padding: "0 13px",
            minHeight: "40px",
            color: state.isSelected ? "white" : "#eeeeee",
            fontWeight: state.isSelected ? "bold" : "normal",
            backgroundColor: state.isFocused ? "#1c1c1c" : "black",
        }),
        indicator: {
            src: DownArrowWhite,
            width: "24px",
        },
    },
    "round-gray": {
        control: (state) => ({
            backgroundColor: "#262a29",
            color: "white",
            borderRadius: "6px",
            border: "solid 1px #aaaaaa",
        }),
        placeholder: {
            color: "#aaaaaa",
        },
        menuList: {
            borderRadius: "6px",
        },
        option: (state) => ({}),
        dropdownIndicator: (state) => ({}),
        indicator: {
            src: DownArrowWhite,
            width: "8px",
        },
    },
};

const customStyles = {
    container: (provided, state) => ({
        ...provided,
        backgroundColor: "black",
        outline: "none",
        border: "none",
        width: "100%",
    }),
    control: (provided, state) => ({
        ...provided,
        minHeight: "30px",
        height: "30px",
        border: "none",
        borderRadius: "2px",
        backgroundColor: state.isDisabled
            ? "#262a29"
            : "rgba(202, 225, 218, 0.5)",
        width: "100%",
        color: "#000000",
        borderColor: "none",
        boxShadow: "none",
        cursor: "pointer",
        ...STYLE_DICT[state.selectProps.mainStyle]?.control(state),
    }),
    valueContainer: (provided, state) => ({
        ...provided,
        minHeight: "30px",
        height: "30px",
        padding: "0px 12px",
        fontSize: "11px",
        ...STYLE_DICT[state.selectProps.mainStyle]?.valueContainer,
    }),
    singleValue: (provided, state) => ({
        position: "absolute",
        top: 0,
        minHeight: "30px",
        height: "30px",
        fontWeight: 700,
        lineHeight: "30px",
        ...STYLE_DICT[state.selectProps.mainStyle]?.singleValue,
    }),
    placeholder: (provided, state) => ({
        ...provided,
        margin: 0,
        ...STYLE_DICT[state.selectProps.mainStyle]?.placeholder,
    }),
    input: (provided, state) => ({
        ...provided,
        margin: 0,
        padding: 0,
        height: "30px",
        outline: "none",
    }),
    indicatorsContainer: (provided, state) => ({
        minHeight: "30px",
        height: "30px",
        ...STYLE_DICT[state.selectProps.mainStyle]?.indicatorsContainer,
    }),
    indicatorSeparator: (provided, state) => ({
        display: "none",
    }),
    dropdownIndicator: (provided, state) => ({
        ...provided,
        paddingTop: "13px",
        paddingRight: "10px",
        ...STYLE_DICT[state.selectProps.mainStyle]?.dropdownIndicator(state),
    }),
    clearIndicator: (provided, state) => ({
        ...provided,
        padding: 4,
    }),
    menu: (provided, state) => ({
        ...provided,
        marginTop: "2px",
        backgroundColor: "#3bd4ae",
        ...STYLE_DICT[state.selectProps.mainStyle]?.menu,
    }),
    menuList: (provided, state) => ({
        ...provided,
        padding: "0",
        borderRadius: "2px",
        ...STYLE_DICT[state.selectProps.mainStyle]?.menuList,
    }),
    option: (provided, state) => ({
        ...provided,
        minHeight: "30px",
        textAlign: "left",
        fontWeight: 700,
        fontSize: "11px",
        cursor: "pointer",
        color: "#000000",
        backgroundColor: state.isFocused ? "#0bb087" : "#3bd4ae",
        ...STYLE_DICT[state.selectProps.mainStyle]?.option(state),
    }),
};

const DropdownIndicator = (props) => {
    const mainStyle = props.selectProps.mainStyle;

    const srcIndicator =
        STYLE_DICT[mainStyle]?.indicator?.src || DownArrowBlack;

    const width = STYLE_DICT[mainStyle]?.indicator?.width || "8px";

    return (
        <components.DropdownIndicator {...props}>
            <img
                alt="dropdown indicator"
                style={{ width }}
                src={srcIndicator}
            />
        </components.DropdownIndicator>
    );
};

const CustomOption = (props) => (
    <components.Option {...props}>
        <div className={styles.optionActive}>
            {props.isSelected ? (
                <img alt="active mark" src={CheckMarkWhite} />
            ) : null}
        </div>
        <div className={styles.optionLabel}>{props.children}</div>
    </components.Option>
);

export default ({
    label,
    ariaLabel,
    onChange,
    options,
    value,
    getOptionValue,
    getOptionLabel,
    dataTestId,
    isDisabled,
    placeholder,
    mainStyle,
    classes,
    maxMenuHeight,
}) => {
    let classNames = [];
    if (Array.isArray(classes)) {
        classNames = classes;
    }

    let customComponents = { DropdownIndicator };
    if (["thick-black", "thick-black-2"].includes(mainStyle))
        customComponents.Option = CustomOption;

    // temporary fix to stop auto-focusing first option when dropdown is open
    const selectRef = useRef();
    useEffect(() => {
        if (selectRef.current && selectRef.current.select) {
            selectRef.current.select.getNextFocusedOption = () => null;
        }
    }, [selectRef]);

    return (
        <React.Fragment>
            <label aria-label={ariaLabel}>
                {label}
            </label>
            <div data-testid={dataTestId}>
            <Select
                ref={selectRef}
                className={classNames.join(" ")}
                classNamePrefix="react-select"
                styles={customStyles}
                options={options}
                // menuIsOpen={true} // for debugging
                components={customComponents}
                onChange={onChange}
                value={!empty(value) ? value : null} // to show placeholder
                getOptionValue={getOptionValue}
                getOptionLabel={getOptionLabel}
                isSearchable={false}
                isDisabled={isDisabled}
                placeholder={placeholder ? placeholder : "Select..."}
                mainStyle={mainStyle}
                aria-label={ariaLabel}
                maxMenuHeight={maxMenuHeight}
            />
            </div>
        </React.Fragment>
    );
};
